import * as yup from 'yup'
import { IntlShape } from 'react-intl'

export const schema = {
  email: ''
}

export const validation = (
  intl: IntlShape
) => {
  const { formatMessage } = intl

  return (
    yup
      .object()
      .shape({
        email: yup
          .string()
          .email(formatMessage({ id: 'validation.emailValid' }))
          .required(formatMessage({ id: 'validation.emailValid' }))
      })
  )
}
